// js
import SecurityDashboardsOverview from '../../components/analytics/SecurityDashboardsOverview';
import { connect } from 'react-redux';
import { getSecurityDashboardsByCategory, getEnabledSecurityDashboardCount, getTotalSecurityDashboardCount } from '../../selectors/analytics/securitySelectors';


const mapStateToProps = state => {

  return {
    enabledDashboardCount: getEnabledSecurityDashboardCount(state),
    totalDashboardCount: getTotalSecurityDashboardCount(state),
    categories: getSecurityDashboardsByCategory(state)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SecurityDashboardsOverview);



// WEBPACK FOOTER //
// ./src/containers/analytics/SecurityDashboardsOverview.js